var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "matrix(-1 0 0 1 100.869 0.52002)",
    fill: "url(#pattern0_359_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_359_14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_359_14",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_359_14",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABz0lEQVR4nO3cPUscURiG4duPKBgMiqSwEuwshdQSOxWb2CRpLPwD/gJLGxubQJoU6VJYCBYWqVIIIUUQhCAYEIRAPhqxUFBjEhamkPGkXN5Xzn3BKRcezrMzuzNzzoAkSZIkSZIkSZIkSZIkSZIk3S+LwA/gF/AiOozgBPjbjN/ASycl1vGtQjrjGngWnKlqC8BVq5RLYD46WM2WmiPjdikXwGx0sJotAzetUs6BmehgNVsB/rRKOQOeRAer2WqrkM44Baajg9VsrVDKT2AqOljN1gulfAMmo4PVbKNQSudCciI6WK16gNeFUo6A8ehwNZfyplDKATAWHa5WfcC7Qin7wGh0uFo9AHYKpXwEhqPD1WoA2C2Usgc8jA5XqyHgQ6GU98BgdLhaPQI+FUrZbk5tCjACfC6UsgX0RwQSPAa+FEp5C/T+b4KeAl8LH3LQ1Tl41VzD3HHo5BP15du0EPIX4imLXKcsJftRV3f4tzcRLwwT8dZJIt5cTMTb74n4gCoRH+Em4iKHZFwGlIgL5RJxKWkiLrZOxO0IibhhJxG3tCUy56bPXNprDtwWnagQXxyQwGzz8oDvwPPoMJIkSZIkSZIkSZIkSZIkSZLoqn8Yw0wjKLUllwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBackArrow);
export default __webpack_public_path__ + "static/media/black-back-arrow.449386d04016e3e343b4511645d76394.svg";
export { ForwardRef as ReactComponent };